import React from 'react'
import { CategoriesTable, Layout } from '../../../Components/Organism'

export const CategoriesPage = () => {
    return (
        <Layout>
            <div className='p-5 md:p-10 font-inter'>
                <CategoriesTable />
            </div>
        </Layout>

    )
}
